import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1751c5ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = { class: "app__title" }
const _hoisted_3 = { class: "day__right__padding" }
const _hoisted_4 = { class: "dates__container" }
const _hoisted_5 = { class: "year__color" }
const _hoisted_6 = { class: "hour__text" }
const _hoisted_7 = { class: "hour__text hour__container" }
const _hoisted_8 = { class: "day__right__padding" }
const _hoisted_9 = {
  key: 0,
  class: "speaker__container"
}
const _hoisted_10 = { class: "image__config__container" }
const _hoisted_11 = { class: "speaker__name" }
const _hoisted_12 = {
  key: 0,
  class: "speaker__title"
}
const _hoisted_13 = { class: "event__title__container" }
const _hoisted_14 = { class: "event__title" }
const _hoisted_15 = { class: "description__text" }
const _hoisted_16 = {
  key: 1,
  class: "text--right pt registration__text column__container",
  id: "actitivyRegistration"
}
const _hoisted_17 = { class: "hour__text" }
const _hoisted_18 = { class: "hour__text hour__container" }
const _hoisted_19 = { class: "day__right__padding" }
const _hoisted_20 = {
  key: 0,
  class: "speaker__container"
}
const _hoisted_21 = { class: "image__config__container" }
const _hoisted_22 = {
  key: 0,
  class: "speaker__title"
}
const _hoisted_23 = { class: "event__title__container" }
const _hoisted_24 = { class: "event__title" }
const _hoisted_25 = { class: "description__text" }
const _hoisted_26 = {
  key: 1,
  class: "text--right registration__text column__container",
  id: "actitivyRegistration"
}
const _hoisted_27 = { class: "column__container description__text" }
const _hoisted_28 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { gutter: 20 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24,
          class: "app__header__title"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("program.events")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24,
          class: "text--center"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("program.program")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { gutter: 20 }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.program, (event, propertyName, index) => {
          return (_openBlock(), _createBlock(_component_el_col, {
            class: "pt_1 column__container",
            key: index,
            xs: 12,
            sm: 6,
            md: 4,
            lg: 4,
            xl: 4
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, {
                style: {"width":"8rem","border-radius":"24px","background":"transparent","cursor":"pointer"},
                onClick: ($event: any) => (_ctx.selectDay(index + 1, event)),
                class: _normalizeClass(_ctx.getActiveClass(index))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass('day__container' + (index + 1))
                  }, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("program.day")), 1),
                    _createElementVNode("span", null, _toDisplayString(index + 1), 1)
                  ], 2),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", {
                      class: _normalizeClass('day__color' + (index + 1))
                    }, _toDisplayString(_ctx.getFormat(propertyName, "day")), 3),
                    _createElementVNode("span", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass('month__color' + (index + 1))
                      }, _toDisplayString(_ctx.getFormat(propertyName, "month")), 3),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.getFormat(propertyName, "year")), 1)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["onClick", "class"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    (_ctx.itemToShow != null)
      ? (_openBlock(), _createBlock(_component_el_row, {
          key: 0,
          gutter: 20,
          class: "events__container"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedEvents, (activity, index) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                xs: 24,
                sm: 12,
                md: 6,
                lg: 6,
                xl: 6,
                key: index
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, {
                    class: _normalizeClass(["activity__card mt-1", 'active' + _ctx.itemToShow])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_6, _toDisplayString(activity.startTime), 1),
                          _createElementVNode("span", _hoisted_7, _toDisplayString(activity.endTime), 1)
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass('eventDay__container' + _ctx.itemToShow)
                        }, [
                          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("program.day")), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.itemToShow), 1)
                        ], 2)
                      ]),
                      (activity.speaker)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("span", null, [
                              _createElementVNode("div", _hoisted_10, [
                                (activity.speaker.picture)
                                  ? (_openBlock(), _createBlock(_component_el_avatar, {
                                      key: 0,
                                      fit: "fill",
                                      class: "image__config",
                                      src: 
                    activity.speaker.picture == ''
                      ? require('@/assets/no_profile_image.png')
                      : activity.speaker.picture
                  
                                    }, null, 8, ["src"]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("span", null, [
                              _createElementVNode("span", _hoisted_11, _toDisplayString(activity.speaker.speakerName), 1),
                              (activity.speaker.title)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(activity.speaker.title), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _createVNode(_component_el_scrollbar, { "max-height": "200px" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("p", _hoisted_14, _toDisplayString(activity.eventName), 1)
                            ]),
                            _createElementVNode("p", _hoisted_15, _toDisplayString(activity.description), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      (_ctx.logged)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            (
                activity.eventType === 'course' && _ctx.userData.status === 'paid'
              )
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.onRegisterActivity(activity, false)),
                                  class: _normalizeClass('apply__button' + _ctx.itemToShow)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("program.registerCourse.register")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "class"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["class"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_el_row, {
          key: 1,
          gutter: 20,
          class: "events__container"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.program, (event, propertyName, dateIndex) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: dateIndex }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event, (activity, index) => {
                  return (_openBlock(), _createBlock(_component_el_col, {
                    xs: 24,
                    sm: 12,
                    md: 6,
                    lg: 6,
                    xl: 6,
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_card, {
                        class: _normalizeClass(["activity__card mt-1", _ctx.getActiveClass(index)])
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", null, [
                              _createElementVNode("span", _hoisted_17, _toDisplayString(activity.startTime), 1),
                              _createElementVNode("span", _hoisted_18, _toDisplayString(activity.endTime), 1)
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass('eventDay__container' + (dateIndex + 1))
                            }, [
                              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("program.day")), 1),
                              _createElementVNode("span", null, _toDisplayString(dateIndex + 1), 1)
                            ], 2)
                          ]),
                          (activity.speaker)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createElementVNode("span", null, [
                                  _createElementVNode("div", _hoisted_21, [
                                    (activity.speaker.picture)
                                      ? (_openBlock(), _createBlock(_component_el_avatar, {
                                          key: 0,
                                          fit: "fill",
                                          class: "image__config",
                                          src: 
                      activity.speaker.picture == ''
                        ? require('@/assets/no_profile_image.png')
                        : activity.speaker.picture
                    
                                        }, null, 8, ["src"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("span", null, [
                                  _createElementVNode("span", null, _toDisplayString(activity.speaker.speakerName), 1),
                                  (activity.speaker.title)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(activity.speaker.title), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("p", _hoisted_24, _toDisplayString(activity.eventName), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _createVNode(_component_el_scrollbar, { "max-height": "120px" }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_25, _toDisplayString(activity.description), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          (_ctx.logged)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                (
                  activity.eventType === 'course' && _ctx.userData.status === 'paid'
                )
                                  ? (_openBlock(), _createBlock(_component_el_button, {
                                      key: 0,
                                      onClick: ($event: any) => (_ctx.onRegisterActivity(activity, false)),
                                      class: _normalizeClass('apply__button' + _ctx.itemToShow)
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("program.registerCourse.register")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick", "class"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["class"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ], 64))
            }), 128))
          ]),
          _: 1
        })),
    _createVNode(_component_el_row, { class: "text-center mb-2 mt-2" }, {
      default: _withCtx(() => [
        (_ctx.eventData.programPDF)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "apply-button-download",
              onClick: _ctx.downloadPDF
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("program.btnDownload")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      center: "",
      modelValue: _ctx.showCheckoutConfirmation,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showCheckoutConfirmation) = $event)),
      width: "50%",
      "destroy-on-close": ""
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("program.warning")), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_28, [
          _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCheckoutConfirmation = false)),
            class: "button-dialog"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("program.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "error",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onRegisterActivity(_ctx.activity, true))),
            class: "button-dialog"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("program.continue")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("program.message")), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}